export class ConfigsEmail {

    constructor(
        public emailUsername?: string,
		public emailPassword?: string,
		public emailConnectionType?: string,
		public emailSmtpHost?: string,
		public emailSmtpPort?: string,
		public emailDestinatarioContratar?: string,
		public emailDestinatarioContato?: string
    ){}
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/configs-email.ts